import { useEffect } from "react"

export default function VersionReporter() {
  useEffect(() => {
    const appVersion = typeof __APP_VERSION__ === "undefined" ? "" : __APP_VERSION__
    console.info(
      `%cℹ️ App version: %c${appVersion}`,
      "color: dodgerblue;",
      "font-weight: 700; color: royalblue"
    )
  }, [])
  return null
}
